import { useMutation, useQueryClient } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export const deleteClassCountTuitionBilling = async (id: string) => {
  const response = await baseAPI.delete<{ message: string }>(
    `/class-count-tuition-billing/${id}`,
  );
  return response.data;
};

export const useDeleteClassCountTuitionBilling = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteClassCountTuitionBilling,
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: [KEYS.CLASS_COUNT_TUITION_BILLING],
      });
    },
  });
};
